import { ua } from './ua';

/**
 * 是否Android系统
 */
export const isAndroid = /android/i.test(ua);

/**
 * 是否iOS系统
 */
export const isIos =
    (ua && /(iphone|ipad|ipod|ios)/i.test(ua)) ||
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window)); // iPadOS13

/**
 * 是否Windows系统
 */
export const isWin = /win/i.test(navigator.platform);

/**
 * 是否Mac系统
 */
export const isMac = /mac/i.test(navigator.platform);

/**
 * 获取iOS系统版本
 */
export const iosVersion = (() => {
    const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    let version: number[];
    if (isIos && match !== undefined && match !== null) {
        version = [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || '0', 10)];
        return parseFloat(version.join('.'));
    }
    return 0;
})();
